// figs — the bare words among a row's children, cut to their capitals
// (soft.fig, styles/soft.module.css). In a row that centres a mark (an icon,
// the gem, a glyph) against words, the words' own box is their capitals and
// digits, so the mark sits on the middle of the digits by construction, with
// no pixel nudges (the operator, 2026-11-03). Marks and other elements pass
// through as they are.

import { Children, type ReactNode } from 'react'
import soft from '../../styles/soft.module.css'

export function figs(children: ReactNode): ReactNode {
  return Children.map(children, (child) =>
    typeof child === 'string' || typeof child === 'number' ? (
      <span className={soft.fig}>{child}</span>
    ) : (
      child
    )
  )
}
